import { mainContainer } from '../../main.module';
import { MessagingInterface, MessagingService } from './messaging.service';

export const Messaging = mainContainer.get<MessagingInterface>(MessagingService);

export { MessageData, MessagingScope } from './messaging.service';
